<template>
  <div id="dropdownUser" v-click-outside="Hide">
    <div v-if="getUserModel" class="user" @click="show = true">
      <div class="userName">
        <div>
          <a>{{ getUserModel.displayName }}</a>
        </div>
        <div>
          <i class="icon-arrow-bropdown"></i>
        </div>
      </div>

      <div class="img">
        <LetterAvatar
          :src="getUserModel.pictureUrl"
          :full-name="getUserModel.displayName"
          :user-id="getUserModel.userId"
          :size="32"
          ignore-src-pattern="logo_peak-default.png"
        />
      </div>
    </div>
    <div :class="['dropdownUser', { show: show }]">
      <div class="box">
        <div v-if="getUserModel" :class="['name']" @click="show = false">{{ getUserModel.displayName }}</div>
        <hr />
        <div class="list" v-for="(option, index) in optionList" :key="index">
          <div v-if="option.outProject" @click="RedirectToPeak(option)">
            <div :class="['option']"><i :class="option.icon"></i>{{ $t(option.name) }}</div>
          </div>
          <router-link v-if="!option.outProject" :to="SetUrl(option)">
            <div :class="['option']"><i :class="option.icon"></i>{{ $t(option.name) }}</div>
          </router-link>
          <div v-if="option.lock" class="lock">
            <i class="fas fa-lock"></i>
            <p>{{ $t("Lock_HeaderMenu") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import LetterAvatar from "@/components/header/LetterAvatar.vue";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLogIn = namespace("LogIn");

@Component({
  components: { LetterAvatar },
})
export default class DropdownUser extends Vue {
  private show = false;
  private optionList = [
    {
      lock: false,
      name: "user_Profile",
      icon: "fa fa-user",
      link: `${process.env.VUE_APP_PeakAccount}profile/profileSetting`,
      outProject: true,
    },
    {
      lock: false,
      name: "user_Subscription",
      icon: "fa fa-credit-card",
      link: `${process.env.VUE_APP_PeakAccount}setting/billing`,
      outProject: true,
    },
    { lock: true, name: "user_Help", icon: "fa fa-question-circle", link: "help" },
    { lock: true, name: "user_InviteFriends", icon: "fa fa-paper-plane", link: "invitation" },
    { lock: false, name: "logout", icon: "fas fa-sign-out-alt", link: "logout" },
  ];

  @StoreLogIn.Getter
  public getUserModel!: any;

  get emi() {
    return MerchantId().PeakEncryption();
  }

  public Hide() {
    this.show = false;
  }

  public SetUrl(option: any) {
    return { name: option.link, query: { emi: this.emi, logout: true } };
  }
  public RedirectToPeak(option: any) {
    window.open(`${option.link}?emi=${this.emi}`);
    this.show = false;
  }
}
</script>

<style lang="scss" scoped>
#dropdownUser {
  margin-left: 20px;
  position: relative;
  .user {
    display: flex;
    align-items: center;
    cursor: pointer;
    .userName {
      display: flex;
      align-items: center;
      a,
      i {
        color: white !important;
        margin-right: 10px;
      }
      i {
        font-size: 10px;
      }
      .status {
        @include p3;
        text-align: center;
        background: rgb(255, 161, 54);
        color: white;
        margin-right: 10px;
        border-radius: 20px;
      }
    }
    img {
      border-radius: 50%;
    }
  }
  .dropdownUser {
    position: absolute;
    top: 0px;
    right: 0px;
    margin-left: -50px;
    width: max-content;
    border-radius: 6px;
    overflow: hidden;
    background: rgb(255, 255, 255);
    z-index: 2;
    max-height: 0px;
    @include shadowboxLv2;
    transition: 0.5s;
    .name {
      text-align: center;
      padding: 15px;
      cursor: pointer;
      transition: all 0.5s ease;
      &:hover {
        color: $green_active;
      }
    }
    hr {
      margin-top: 0px;
      width: 80%;
    }
    a {
      color: unset;
    }
    .list {
      position: relative;
    }
    .option {
      position: relative;
      display: flex;
      align-items: center;
      padding: 10px 20px 10px 10px;
      cursor: pointer;
      transition: all 0.5s ease;

      i {
        font-size: 14px;
        width: 30px;
        text-align: center;
      }
      &:hover {
        color: $green_active;
        background: $hover;
      }
    }
  }
  .show {
    max-height: 500px;
  }

  .lock {
    content: " ";
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    background: rgba(255, 255, 255, 0.85);
    p,
    i {
      color: white;
      display: none;
    }
    i {
      margin-right: 10px;
      font-size: 10px;
    }
    &:hover {
      background: rgba(26, 26, 26, 0.85);
      p,
      i {
        display: unset;
      }
    }
  }
}
</style>
